module.exports = __webpack_public_path__ + "d5876a11cb9704e4e9818ce6909f4f6f.jpg";